<app-core
    [type]="type"
    [titleForm]="titleForm"
    [items]="[]"
    [listadoPersonalizado]="true"
>
    <app-asociados-listado></app-asociados-listado>
</app-core>
